import { render } from "./CadastroTipoOperadoraView.vue?vue&type=template&id=371a0976"
import script from "./CadastroTipoOperadoraView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoOperadoraView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__